import posthog from './posthog';

const useEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';

function captureException(error: unknown, properties?: Record<string, unknown>) {
  if (useEmulators) return;

  console.error('[Monitoring] Exception captured:', error);

  try {
    posthog.captureException(error, properties);
  } catch (err) {
    console.warn('PostHog captureException failed:', err);
  }
}

export const monitoringClient = {
  captureException,
};
